module.exports = __webpack_public_path__ + "img/certificate-3.3cd21e5e.png";